<template lang="pug">
div
  .ToggleThumbnailGroup.nl1-ns.nr1-ns
    .ToggleThumbnail.gutter.mt2.mt0-ns.tc(
      v-for='(option, optI) in model.options',
      v-if='!disabledOptions.includes(option.id)',
      :class=`{
        'ToggleThumbnail--selected': currentOptionIndex === optI,
        'ToggleThumbnail--disabled': disabledOptions.includes(option.id)
      }`
    )
      .cell.w-100
        .ToggleThumbnailBox(
          @click.prevent='selectOption(option, optI)',
        )
          .Thumbnail.aspect-ratio.aspect-ratio--1x1
            .aspect-ratio--object.cover( :style='thumbnails[optI]' )

          .ToggleThumbnailInfos.ph2.pv3.ph3-l.pv3-l
            .ToggleThumbnailName {{ option.name | ratio }}

        .ToggleThumbnailInfos.pt1.pt2-l.pb3(v-if='option.description')
          .ToggleThumbnailDescription(v-html='option.description')

  div(v-if='selectedOption.customField')
    input(v-model.lazy='selectedOption.customFieldData' :placeholder='selectedOption.description')

  p.f6.lh-copy.measure.ToggleError.dark-red(
    v-if='!areAllOptionsDisabled && isCurrentOptionDisabled'
  ) Please select an available option

  p.f6.lh-copy.measure.ToggleError.dark-red(
    v-if='isCustomFieldEmpty'
  ) Please enter a description

</template>

<script>

import numeral from 'numeral'

export default {
  name: 'bookart-toggle-thumbnail',

  props: ['value', 'selectedOptionIndex'],

  data () {
    const thumbnails = this.value.options.map(option => {
      /* hardcoded - must be updated */
      const s3Path = 'https://bucketeer-5f67835c-44c6-4254-99e2-1da74ddb85cf.s3.amazonaws.com/public/'

      return !!option.thumbnail
        ? `background-image: url(${s3Path}${this.value.id}-${option.id}.jpg?${+new Date()})`
        : null
    })

    return {
      currentOptionIndex: this.selectedOptionIndex,
      thumbnails,
    }
  },

  watch: {
    currentOptionIndex (optionI) {
      this.$parent.$emit('select', optionI)
    }
  },

  computed: {
    selectedOption () {
      return this.model.options[this.currentOptionIndex]
    },
    disabledOptions () {
      return this.$parent.$parent.disabledOptions
    },
    isCurrentOptionDisabled () {
      return this.disabledOptions
        .includes(this.selectedOption.id)
    },
    areAllOptionsDisabled () {
      return this.model.options
        .every(option => this.disabledOptions.includes(option.id))
    },
    isCustomFieldEmpty() {
      return this.selectedOption.customField && !this.selectedOption.customFieldData
    },
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    selectOption (option, optI) {
      if (!this.disabledOptions.includes(option.id))
        this.currentOptionIndex = optI
    }
  },
  filters: {
    ratio (val) {
      return val.replace(/([0-9]+)x([0-9]+)/gi, '$1 × $2')
    },
    price (val) {
      return numeral(val).format('$ 0,0.00')
    }
  }
}
</script>

<style lang="stylus" scoped>

$lavender = #333
$mid-lavender = #555
$lavender = #9c84f0
$mid-lavender = #c9c3df

$breakpoints = {
  ns: 'screen and (min-width: 30em)',
  m: 'screen and (min-width: 30em) and (max-width: 60em)',
  l: 'screen and (min-width: 60em)'
}
$gutter = 10px

clearfix()
  *zoom: 1
  &::before, &::after
    content: ' '
    display: table
  &::after
    clear: both

.ToggleThumbnailGroup
  display: flex
  flex-wrap: wrap
  justify-content: flex-start

  margin-top: -1 * $gutter
  margin-left: -1 * $gutter

.ToggleThumbnailGroup .ToggleThumbnail
  margin-top: $gutter
  margin-left: $gutter

  width: "calc(50% - %s)" % $gutter

  @media $breakpoints['m']
    width: "calc(33.33% - %s)" % $gutter

  @media $breakpoints['l']
    width: "calc(25% - %s)" % $gutter

  text-align: center
  text-decoration: none

  cursor: pointer
  color: near-black
  background-color: white

  .ToggleThumbnailBox
    border: 1px dashed $lavender
    opacity: 1
    transition: background-color .2s, opacity .2s

  @media $breakpoints['ns']
    .ToggleThumbnailBox
      &:hover, &:active
        color: white
        background-color: $mid-lavender

        .ToggleThumbnailName
          color: white

  &.ToggleThumbnail--selected .ToggleThumbnailBox
    color: white
    background-color: $lavender
    border: 1px solid $lavender

    .ToggleThumbnailName
      color: white

  &.ToggleThumbnail--disabled
    position: relative
    z-index: -1
    cursor: default
    color: rgba(0, 0, 0, 0.2)

    .ToggleThumbnailDescription /deep/ a
      color: rgba(0, 0, 0, 0.2)

    .ToggleThumbnailBox
      border-color: transparent
      background-color: rgba(0, 0, 0, 0.1)

    .aspect-ratio--object
      opacity: .5

.ToggleThumbnailName
  text-transform: uppercase
  font-weight: bold
  color: $lavender

  font-size: .8em

  @media $breakpoints['ns']
    font-size: 1em

.ToggleThumbnailDescription
  margin-top: .5rem
  font-size: 0.9em
  line-height: 1.4em

.ToggleThumbnailPrice
  display: inline-block
  background: #f5f5f5
  padding: 4px 7px
  margin-top: 1rem
  color: $lavender
  font-size: 12px

  .ToggleThumbnail--disabled &
    opacity: 0.3

.ToggleThumbnail.ToggleThumbnail--selected .ToggleThumbnailPrice
  background-color: lighten($lavender, 30%)
  color: white

.ToggleThumbnail:hover .ToggleThumbnailPrice
  @media $breakpoints['ns']
    background-color: lighten($lavender, 30%)
    color: white

.Thumbnail
  background-image: url(./placeholder.png)

.ToggleThumbnailInfos
  text-align: left
</style>



// WEBPACK FOOTER //
// BookartToggleThumbnail.vue?9fe93d32